import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { postAxios } from "../../../Services/commonService";
import { API_POST_SPORT } from "../../../../utils/api/ApiConstant";
import { Button, Error, Label } from "../..";
import SportSchema from "../../../Schema/Game/SportSchema";
import { uiActions } from "../../../../store/ui/ui-slice";

const SportModal = ({ handleModalHide, rowData, fetchData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      displayOrder: "",
    },
    resolver: yupResolver(SportSchema),
  });

  const onSubmit = async (values) => {
    const res = await postAxios(API_POST_SPORT, values);
    if (res) {
      fetchData();
      handleModalHide();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row m-0 p-0">
        {/* Sport Name */}
        <div className="col-md-6 m-0 p-1">
          <Label htmlFor="name" className="form-label" isRequired={true}>
            Sport name
          </Label>
          <input
            type="text"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            id="name"
            placeholder="Enter sport name"
            autoFocus={true}
            {...register("name")}
          />
          {errors.name && <Error>{errors.name.message}</Error>}
        </div>

        <div className="col-md-6 m-0 p-1">
          <Label
            htmlFor="displayOrder"
            className="form-label"
            isRequired={true}
          >
            Display Order
          </Label>
          <input
            type="number"
            className={`form-control ${errors.id ? "is-invalid" : ""}`}
            id="id"
            placeholder="Enter id"
            {...register("displayOrder")}
          />
          {errors.id && <Error>{errors.id.message}</Error>}
        </div>
      </div>
      <Button type="submit" className="btn btn_main">
        Add
      </Button>
      <Button type="button" className="btn btn_main" onClick={handleModalHide}>
        Close
      </Button>
    </form>
  );
};

export default SportModal;
